import { useCallback, useState } from "react";

export const useServerPagination = ({
  initialPage = 0,
  initialPageSize = 10,
  onPageChange,
}) => {
  const [paginationModel, setPaginationModel] = useState({
    page: initialPage,
    pageSize: initialPageSize,
  });

  const setPage = useCallback(
    (nextPage) => {
      setPaginationModel((prev) => {
        if (prev.page === nextPage) return prev;
        const nextModel = { ...prev, page: nextPage };
        if (onPageChange) onPageChange(nextModel);
        return nextModel;
      });
    },
    [onPageChange],
  );

  const setPageSize = useCallback(
    (nextPageSize) => {
      setPaginationModel((prev) => {
        if (prev.pageSize === nextPageSize) return prev;
        const nextModel = { page: 0, pageSize: nextPageSize };
        if (onPageChange) onPageChange(nextModel);
        return nextModel;
      });
    },
    [onPageChange],
  );

  const onGridPaginationChanged = useCallback((params) => {
    if (!params?.api) return;

    const nextPage = params.api.paginationGetCurrentPage();
    const nextPageSize = params.api.paginationGetPageSize();

    setPaginationModel((prev) => {
      if (prev.page === nextPage && prev.pageSize === nextPageSize) {
        return prev;
      }

      const isPageSizeChanged = prev.pageSize !== nextPageSize;
      const nextModel = {
        page: isPageSizeChanged ? 0 : nextPage,
        pageSize: nextPageSize,
      };

      if (onPageChange) onPageChange(nextModel);
      return nextModel;
    });
  }, [onPageChange]);

  const resetPagination = useCallback(() => {
    setPaginationModel({ page: 0, pageSize: initialPageSize });
    if (onPageChange) {
      onPageChange({ page: 0, pageSize: initialPageSize });
    }
  }, [initialPageSize, onPageChange]);

  return {
    paginationModel,
    setPaginationModel,
    setPage,
    setPageSize,
    resetPagination,
    onGridPaginationChanged,
  };
};
